import type { Optional } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'

type FPlusScopeFilterValueContextProps = {
  filterValue: Optional<string>
  setFilterValue: (filterValue: Optional<string>) => void
}

const [useFPlusScopeFilterValue, Provider] =
  createRequiredContext<FPlusScopeFilterValueContextProps>('ScopeFilterValue')

export { Provider, useFPlusScopeFilterValue }
